module.exports = __webpack_public_path__ + "img/lazerball.b94d6ca1.jpg";